// extracted by mini-css-extract-plugin
export default {"container":"columns-module--container--N7MDI","column_wrapper":"columns-module--column_wrapper--xTAEj"};